var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alert",class:_vm.classes,attrs:{"role":"alert"}},[_c('div',{staticClass:"alert__icon"},[_c('img',{attrs:{"src":'/images/icons/' + _vm.type + '.svg'}})]),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }